<template>
    <b-dropdown
        ref="wellStatusDropdown"
        variant="transparent"
        menu-class="w-100"
        :class="['well-status-controls', 'selected-item', well.status]"
        no-caret
        @hide="preventHideForFda"
    >
        <template v-slot:button-content>
            <span class="item-content" :class="{ 'fate-status': currentFateText }">
                {{ $translate(currentStatusText) }}
                <img
                    :src="`${WELL_STATUS_ICONS_PATH}/${well.status || 'DEFAULT'}.svg`"
                    :class="currentIconClass"
                    alt=""
                />
            </span>
        </template>

        <b-dropdown-item
            v-for="(status, index) in dropdownOptions"
            :key="index"
            :class="['item-status', isFdaFriendly ? 'NA' : status.key]"
            @click="changeWellStatus(status.key)"
        >
            <span class="item-content" :class="{ 'fda-friendly': isFdaFriendly }">
                {{ $translate(status.actionLabel) }}
                <img
                    :src="`${WELL_STATUS_ICONS_PATH}/${status.key}.svg`"
                    :class="status.iconClass"
                    alt=""
                />
            </span>
        </b-dropdown-item>

        <b-dropdown-item
            v-if="well.status"
            class="item-status NA"
            @click="changeWellStatus(well.status)"
        >
            <span class="item-content">
                {{ $translate('na') }}
            </span>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
import { WELL_STATUS } from '../../../business/factory/DataModel'
import { WELL_STATUS_ICONS_PATH } from '../../../business/const'
const { PENDING, FROZEN, THAWED, TRANSFERRED, DISCARDED } = WELL_STATUS

export default {
    name: 'WellStatusControls',
    props: {
        well: {
            type: Object,
            required: true
        },
        keepOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            WELL_STATUS_ICONS_PATH,
            el: null,
            config: [
                {
                    key: PENDING,
                    actionLabel: 'pending',
                    iconClass: 'pending-button'
                },
                {
                    key: FROZEN,
                    actionLabel: 'freeze',
                    iconClass: 'frozen-button'
                },
                {
                    key: THAWED,
                    actionLabel: 'thawed',
                    iconClass: 'thawed-button'
                },
                {
                    key: TRANSFERRED,
                    actionLabel: 'transfer',
                    iconClass: 'transferred-button'
                },
                {
                    key: DISCARDED,
                    actionLabel: 'discard',
                    iconClass: 'discard-button'
                }
            ]
        }
    },
    computed: {
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly'
        }),
        dropdownOptions() {
            return this.config.filter(option => option.key !== this.well.status)
        },
        currentStatusConfig() {
            return this.config.find(option => option.key === this.well.status)
        },
        currentStatusText() {
            if (!this.well.status || !this.currentStatusConfig) {
                return 'Fate'
            }
            return this.currentStatusConfig.actionLabel
        },
        currentFateText() {
            return this.currentStatusText === 'Fate'
        },
        currentIconClass() {
            if (!this.well.status || !this.currentStatusConfig) {
                return 'select-button'
            }
            return this.currentStatusConfig.iconClass
        }
    },
    mounted() {
        this.el = this.$refs.wellStatusDropdown

        if (this.isFdaFriendly && this.keepOpen && this.el) {
            this.el.show()
        }
    },
    methods: {
        changeWellStatus(status) {
            this.$mainController.changeWellStatus(this.well, status)
        },
        preventHideForFda(e) {
            if (this.isFdaFriendly && this.keepOpen) e.preventDefault()
        }
    }
}
</script>

<style lang="scss" scoped>
.well-status-controls {
    color: $light-3;
    border: 1px solid white;
    border-radius: $border-radius;
    background-color: $dark-4;

    img {
        height: 1rem;
    }

    &.selected-item {
        &.PENDING {
            border: 1px solid $yellow;
            span {
                color: $yellow;
            }
        }
        &.FROZEN {
            border: 1px solid $frozen-color;
            span {
                color: $frozen-color;
            }
        }
        &.THAWED {
            border: 1px solid $purple;
            span {
                color: $purple;
            }
        }
        &.TRANSFERRED {
            border: 1px solid $green;
            span {
                color: $green;
            }
        }
        &.DISCARDED {
            border: 1px solid $red;
            span {
                color: $red;
            }
        }
    }

    .fate-status:active {
        color: white;
    }

    &.focused {
        min-width: 7.8rem;
        @media screen and #{$new-break4} {
            flex-grow: 1;
        }
    }

    .item-content {
        padding: 0 0.4rem;
        display: flex;
        justify-content: space-between;

        &.fda-friendly {
            padding-block: 3px;
        }
    }
    .item-status {
        border-radius: $border-radius;
        margin-bottom: 0.2rem;
        border: solid 1px $light-alpha;

        &.PENDING {
            span {
                color: $yellow;
            }
        }
        &.FROZEN {
            span {
                color: $frozen-color;
            }
        }
        &.THAWED {
            span {
                color: $purple;
            }
        }
        &.TRANSFERRED {
            span {
                color: $green;
            }
        }
        &.DISCARDED {
            span {
                color: $red;
            }
        }
        &.NA {
            span {
                color: $gray-500;
            }
        }
    }
}
</style>

<style lang="scss">
.well-status-controls {
    .btn {
        font-size: 10.5px;
        border-radius: 0.3rem;
    }

    .dropdown-menu {
        min-width: unset;
    }
    .dropdown-item {
        font-size: 10.5px;
        padding: 0.1rem 0;
    }
    .dropdown-item:hover {
        background-color: unset;
    }
}
</style>

